import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { styled } from '@mui/material';
import MuiBox from '@mui/material//Box';
import MuiTypography from '@mui/material/Typography';
import useGlobalStyles from '../../theme/global.js';
import BasicModal from '../BaseDialog/BaseDialog.js';
import Actions from './Actions.js';
import DialogScrollContent from './DialogScrollContent.js';

const _BaseDialog = styled(BasicModal) `
  min-width: 400px;
  align-items: flex-start;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(6, 0, 8)};
`;
const TextWrapper = styled(MuiBox, {
    shouldForwardProp: prop => !['withIconPadding', 'denseMargin'].includes(prop),
}) `
  display: flex;
  flex-direction: column;
  margin: ${({ theme, withIconPadding, denseMargin }) => theme.spacing(0, 0, 0, !withIconPadding ? 0 : denseMargin ? 4 : 8)};
`;
const Title = styled(MuiTypography, {
    shouldForwardProp: prop => !['denseMargin'].includes(prop),
}) `
  overflow-wrap: anywhere;
  width: 100%;
  ${({ theme, denseMargin }) => `
    color: ${theme.palette.N20.main};
    margin: ${theme.spacing(0, 0, denseMargin ? 2 : 4)};
  `}
`;
const Description = styled(Title) `
  color: ${({ theme }) => theme.palette.N10.main};
  white-space: pre-line;
`;
const Header = styled(MuiBox) `
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(0, 8)};
`;
const Icon = styled('span', {
    shouldForwardProp: prop => !['iconPosition'].includes(prop),
}) `
  display: flex;
  align-self: ${({ iconPosition }) => (!!iconPosition ? iconPosition : 'center')};
`;
const ContentDialog = (_a) => {
    var { responsive, icon, iconPosition, denseMargin, title, description, mainActions, sideAction, children, disableScrollWrapper } = _a, rest = __rest(_a, ["responsive", "icon", "iconPosition", "denseMargin", "title", "description", "mainActions", "sideAction", "children", "disableScrollWrapper"]);
    useGlobalStyles();
    const withIconPadding = React__default.isValidElement(icon);
    return (jsxs(_BaseDialog, Object.assign({}, rest, { children: [jsxs(Header, { children: [jsx(Icon, Object.assign({ iconPosition: iconPosition }, { children: icon })), jsxs(TextWrapper, Object.assign({ withIconPadding: withIconPadding, denseMargin: denseMargin }, { children: [jsx(Title, Object.assign({ variant: "h2", denseMargin: denseMargin }, { children: title })), description &&
                                (typeof description === 'string' ? jsx(Description, Object.assign({ variant: "body1" }, { children: description })) : description)] }))] }), disableScrollWrapper ? children : jsx(DialogScrollContent, Object.assign({ responsive: responsive }, { children: children })), jsx(Actions, { mainActions: mainActions, sideAction: sideAction })] })));
};

export { ContentDialog as default };
//# sourceMappingURL=ContentDialog.js.map
